/*
 * pf-merch-instrument.js — B-14 #1 (merchandising console), slice 1.
 *
 * Emits placement-performance signals for homepage rails into the existing
 * GTM dataLayer. Pure-additive, read-only over the DOM — it never changes how
 * rails render. Pairs with the server-side placement log (what was placed) to
 * answer "does rail position drive sales."
 *
 * Events pushed (all flat, GTM-variable friendly):
 *   merch_rail_impression  — a rail scrolled into view (once per rail/pageview)
 *   merch_rail_click       — a product link inside a rail was clicked
 *
 * Rails are tagged in random-carousel-collections.liquid with:
 *   [data-merch-rail] data-merch-position data-merch-block
 *   data-merch-collection data-merch-title, under a [data-merch-page] wrapper.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function railContext(rail) {
    var pageEl = rail.closest('[data-merch-page]');
    return {
      merch_page: pageEl ? pageEl.getAttribute('data-merch-page') : '',
      merch_position: parseInt(rail.getAttribute('data-merch-position'), 10) || null,
      merch_block: rail.getAttribute('data-merch-block') || '',
      merch_collection: rail.getAttribute('data-merch-collection') || '',
      merch_title: rail.getAttribute('data-merch-title') || ''
    };
  }

  // ---- Impressions (fire once per rail when ≥50% visible) ----
  function initImpressions(rails) {
    if (!('IntersectionObserver' in window)) {
      // No IO support: count them as impressed up front rather than losing the signal.
      rails.forEach(function (rail) {
        window.dataLayer.push(Object.assign({ event: 'merch_rail_impression' }, railContext(rail)));
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var rail = entry.target;
        observer.unobserve(rail);
        window.dataLayer.push(Object.assign({ event: 'merch_rail_impression' }, railContext(rail)));
      });
    }, { threshold: 0.5 });
    rails.forEach(function (rail) { observer.observe(rail); });
  }

  // ---- Clicks (delegated: any product link inside a rail) ----
  function productHandle(href) {
    try {
      var path = new URL(href, window.location.origin).pathname;
      var i = path.indexOf('/products/');
      if (i === -1) return '';
      return path.slice(i + '/products/'.length).split('/')[0].split('?')[0];
    } catch (e) {
      return '';
    }
  }

  function productPosition(link) {
    var slide = link.closest('.slider__slide, li');
    if (!slide || !slide.parentElement) return null;
    var siblings = slide.parentElement.children;
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] === slide) return i + 1;
    }
    return null;
  }

  function initClicks() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href*="/products/"]');
      if (!link) return;
      var rail = link.closest('[data-merch-rail]');
      if (!rail) return;
      var ctx = railContext(rail);
      ctx.event = 'merch_rail_click';
      ctx.merch_product = productHandle(link.getAttribute('href') || '');
      ctx.merch_product_position = productPosition(link);
      window.dataLayer.push(ctx);
    }, { capture: true });
  }

  function init() {
    var rails = Array.prototype.slice.call(document.querySelectorAll('[data-merch-rail]'));
    if (rails.length) initImpressions(rails);
    initClicks(); // delegated once; cheap even if no rails on this page
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
